export default __webpack_public_path__ + "static/media/bg-balao-03.2454b277.png";